// Helper parse host từ git remote URL (https hoặc SSH) và detect GitHub host.
// Dùng để quyết định flow credential phù hợp (gh auth setup-git vs PAT manual).
//
// Supported formats:
//   https://gitlab.nal.vn/a/b             → gitlab.nal.vn
//   git@gitlab.nal.vn:a/b.git             → gitlab.nal.vn
//   https://github.com/owner/repo      → github.com
//   git@github.com:owner/repo.git      → github.com
//   ssh://git@github.com/owner/repo    → github.com   (bug #68 review MAJOR-1)
//   ssh://git@gitlab.nal.vn:2222/a/b.git  → gitlab.nal.vn:2222

/**
 * Parse host từ HTTPS hoặc SSH git remote URL.
 * Return null nếu URL không parse được (format lạ).
 *
 * Port (nếu có) GIỮ NGUYÊN trong host trả về — git credential helper match theo
 * host[:port], strip port ở đây sẽ làm PAT lưu sai key. So sánh GitHub bỏ port
 * là việc của isGithubHost().
 */
export function parseGitRemoteHost(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;

  // URL-scheme: http(s)://... và ssh://... — bóc authority [userinfo@]host[:port],
  // loại userinfo, giữ host:port NGUYÊN VĂN. (Không dùng new URL(): nó strip
  // default port :443/:80 → lệch key credential match.)
  const schemeMatch = trimmed.match(/^(?:https?|ssh):\/\/(?:[^/@]+@)?([^/]+)/i);
  if (schemeMatch) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return schemeMatch[1]!.toLowerCase();
  }

  // SSH SCP-style: git@host:path (không phải URL chuẩn — new URL() không parse được)
  const sshMatch = trimmed.match(/^git@([^:]+):/);
  if (sshMatch) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return sshMatch[1]!.toLowerCase();
  }

  return null;
}

/**
 * Kiểm tra host có phải GitHub không (chỉ github.com, case-insensitive).
 * github.com / github.com:443 → true; gitlab.nal.vn, gitlab.com, bitbucket.org → false.
 */
export function isGithubHost(host: string | null): boolean {
  if (!host) return false;
  // Bỏ port khi so sánh (github.com:443 vẫn là GitHub) — parseGitRemoteHost
  // giữ port cho credential-store, chỉ chỗ compare này mới strip.
  return host.toLowerCase().replace(/:\d+$/, "") === "github.com";
}
